module.exports = __webpack_public_path__ + "img/二维码.958a03d7.png";